import React, { Fragment } from "react";
import {Application, useApps} from "~/catalog/hooks";
import {makeStyles} from "@mui/styles";
import {CatalogGridItem} from "~/catalog/components/CatalogGridItem";
import {useHistory} from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, 88px)",
        gridColumnGap: "4%",
        gridRowGap: "4%",
        justifyContent: "center",
    },
}))


export const CatalogGrid = () => {
    const history = useHistory();
    const classes = useStyles();
    const {data, loading} = useApps();

    const handleItemClick = (item: Application) => {
        if (item.type == "internal") {
            history.push(`/apps/${encodeURI(item.id)}`);
        } else if (item.type == "external") {
            history.push(`/apps/external/${encodeURIComponent(item.uri)}`);
        }
    }

    return (
            <div className={classes.root}>
                {data?.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <CatalogGridItem application={item} onClick={() => handleItemClick(item)} disabled={item.disabled}/>
                        </Fragment>
                    );
                })}
            </div>
    );
}